<ng-container *ngIf="cs.vm$ | async as vm">
  <dgx-components-grid-section
    [theme]="'background-alternative'"
    [themeFlush]="true"
  >
    <dgx-components-grid-container>
      <dgx-components-card
        [spacing]="5"
        class="pb-5 direct-debit__card-container"
      >
        <dgx-components-grid-row class="mb-4">
          <dgx-components-grid-column [xs]="12">
            <checkout-progression-steps />
          </dgx-components-grid-column>
        </dgx-components-grid-row>

        <dgx-components-grid-row>
          <dgx-components-grid-column>
            <h1 class="direct-debit-title">
              {{ vm.cmsData.pageTitle }}
            </h1>

            <h2 class="direct-debit-subtitle">
              {{ 'DIRECT_DEBIT_DETAILS_SUBTITLE' | translate }}
            </h2>
          </dgx-components-grid-column>
        </dgx-components-grid-row>

        <dgx-components-grid-row>
          <dgx-components-grid-column [md]="6" [xs]="12">
            <p
              *ngIf="vm.basketItemsFirstQuotesHasFirstMonthFreePromotionalOffer"
              class="typog-body-lg mb-3"
            >
              {{
                vm.hasMonthsFreePromotionalOffer
                  ? ('DIRECT_DEBIT_FORM_VARIABLE_PROMOTION_PAYMENT'
                    | translate
                      : {
                          monthsFree:
                            vm.requestedBasketItemFirstQuote | quoteFreeMonths,
                          quote: vm.monthlyPayment | currencyFormat
                        })
                  : ('DIRECT_DEBIT_FORM_FIRST_MONTH_PAYMENT'
                    | translate : { quote: vm.monthlyPayment | currencyFormat })
              }}
            </p>
            <checkout-direct-debit-form (submitted)="cs.onFormSubmit($event)" />
          </dgx-components-grid-column>

          <dgx-components-grid-column [md]="6" [xs]="12">
            <div class="direct-debit__aside">
              <dgx-basket-summary [canRemoveSelectedQuotes]="false" />
            </div>
          </dgx-components-grid-column>
        </dgx-components-grid-row>
      </dgx-components-card>

      <dgx-components-button-navigate-back />
    </dgx-components-grid-container>
  </dgx-components-grid-section>

  <div [content]="main" editable-area></div>
</ng-container>
